(function () {
  'use strict';

  var container = document.getElementById('custom-form-container');
  if (!container) return;

  var form = document.getElementById('custom-request-form');
  var dropZone = document.getElementById('custom-drop-zone');
  var fileInput = document.getElementById('custom-photos');
  var previewsEl = document.getElementById('custom-previews');
  var successEl = document.getElementById('custom-success');
  var errorEl = document.getElementById('custom-error');

  var webhookUrl = container.dataset.webhookUrl || '';
  var maxFiles = parseInt(container.dataset.maxFiles, 10) || 5;
  var maxSizeMb = parseInt(container.dataset.maxSizeMb, 10) || 5;
  var maxSizeBytes = maxSizeMb * 1024 * 1024;

  var selectedFiles = [];
  var photosErrorEl = document.getElementById('custom-photos-error');
  var shrinkAboveBytes = 2 * 1024 * 1024;
  var shrinkMaxSide = 2048;

  // Anti-spam: timestamp d'affichage du form (time-trap)
  var loadedAtEl = document.getElementById('custom-form-loaded-at');
  if (loadedAtEl) loadedAtEl.value = String(Date.now());
  var MIN_FILL_MS = 3000;

  // Le binding hCaptcha du form caché (requis pour que son submit natif passe)
  // ne se déclenche que sur interaction — data-shopify-captcha ne suffit pas :
  // on simule un focusin dès le chargement pour binder en avance.
  var fallbackFormEl = document.getElementById('shopify-contact-fallback');
  if (fallbackFormEl) fallbackFormEl.dispatchEvent(new Event('focusin', { bubbles: true }));

  // Attend que le hCaptcha Shopify soit bindé sur le form avant de soumettre :
  // un submit sur un form protégé non bindé est avalé (preventDefault) sans suite.
  function whenCaptchaBound(formEl, cb) {
    if (formEl.dataset.hcaptchaBound || formEl.dataset.recaptchaBound) { cb(); return; }
    formEl.dispatchEvent(new Event('focusin', { bubbles: true }));
    var waited = 0;
    var timer = setInterval(function () {
      waited += 200;
      if (formEl.dataset.hcaptchaBound || formEl.dataset.recaptchaBound || waited >= 5000) {
        clearInterval(timer);
        cb();
      }
    }, 200);
  }

  // Arrivée depuis une fiche produit (bloc « Envie d'une version unique de Kali ? ») :
  // ?design=Kali&from=<handle> pré-remplit la description et voyage dans les champs cachés.
  (function prefillDesign() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var design = (params.get('design') || '').trim().slice(0, 60);
    var from = (params.get('from') || '').trim().slice(0, 120);
    var designEl = form.querySelector('[name="design"]');
    var fromEl = form.querySelector('[name="source_product"]');
    if (designEl) designEl.value = design;
    if (fromEl) fromEl.value = from;
    if (!design) return;
    var descEl = form.querySelector('[name="description"]');
    var tpl = container.dataset.designPrefill || '';
    if (descEl && !descEl.value && tpl) {
      descEl.value = tpl.replace('__DESIGN__', design);
      descEl.dispatchEvent(new Event('input', { bubbles: true }));
    }
  })();

  // Retour du filet Shopify (soumission native /contact) → écran de succès
  if (window.location.search.indexOf('contact_posted=true') !== -1) {
    showSuccess();
  }

  // --- Drop zone ---
  dropZone.addEventListener('click', function () {
    fileInput.click();
  });

  dropZone.addEventListener('dragover', function (e) {
    e.preventDefault();
    dropZone.classList.add('is-dragover');
  });

  dropZone.addEventListener('dragleave', function () {
    dropZone.classList.remove('is-dragover');
  });

  dropZone.addEventListener('drop', function (e) {
    e.preventDefault();
    dropZone.classList.remove('is-dragover');
    handleFiles(e.dataTransfer.files);
  });

  fileInput.addEventListener('change', function () {
    handleFiles(fileInput.files);
    fileInput.value = '';
  });

  function isImageFile(file) {
    if (file.type && file.type.startsWith('image/')) return true;
    var ext = (file.name || '').split('.').pop().toLowerCase();
    return ['jpg','jpeg','jfif','png','gif','webp','heic','heif','bmp','tiff','tif','svg'].indexOf(ext) !== -1;
  }

  function isPdfFile(file) {
    return file.type === 'application/pdf' || /\.pdf$/i.test(file.name || '');
  }

  // Une photo de téléphone dépasse souvent 5 Mo : on la réduit ici plutôt que
  // de l'écarter en silence (deux demandes d'octobre 2026 arrivées sans photo).
  function shrinkImage(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        var scale = Math.min(1, shrinkMaxSide / Math.max(img.naturalWidth, img.naturalHeight));
        var canvas = document.createElement('canvas');
        canvas.width = Math.round(img.naturalWidth * scale);
        canvas.height = Math.round(img.naturalHeight * scale);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(function (blob) {
          if (!blob) { reject(); return; }
          resolve(new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }));
        }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(); };
      img.src = url;
    });
  }

  function handleFiles(fileList) {
    var files = Array.prototype.slice.call(fileList);
    var tooLarge = [];
    var notImage = [];
    if (photosErrorEl) photosErrorEl.style.display = 'none';

    var chain = Promise.resolve();
    files.forEach(function (file) {
      chain = chain.then(function () {
        if (selectedFiles.length >= maxFiles) return;
        if (isPdfFile(file)) {
          if (file.size > maxSizeBytes) { tooLarge.push(file.name); return; }
          selectedFiles.push(file);
          return;
        }
        if (!isImageFile(file)) { notImage.push(file.name); return; }
        if (file.size <= shrinkAboveBytes) { selectedFiles.push(file); return; }
        return shrinkImage(file).then(function (small) {
          if (small.size > maxSizeBytes) { tooLarge.push(file.name); return; }
          selectedFiles.push(small);
        }, function () {
          if (file.size > maxSizeBytes) { tooLarge.push(file.name); return; }
          selectedFiles.push(file);
        });
      });
    });

    chain.then(function () {
      renderPreviews();
      var lines = [];
      if (notImage.length) lines.push((container.dataset.msgNotImage || '') + ' ' + notImage.join(', '));
      if (tooLarge.length) lines.push((container.dataset.msgTooLarge || '') + ' ' + tooLarge.join(', '));
      if (lines.length && photosErrorEl) {
        photosErrorEl.textContent = lines.join(' ');
        photosErrorEl.style.display = 'block';
      }
    });
  }

  function renderPreviews() {
    previewsEl.innerHTML = '';
    selectedFiles.forEach(function (file, idx) {
      var wrapper = document.createElement('div');
      wrapper.className = 'custom-form__preview';

      var img;
      if (isPdfFile(file)) {
        img = document.createElement('span');
        img.className = 'custom-form__preview-pdf';
        img.textContent = 'PDF';
        img.title = file.name;
      } else {
        img = document.createElement('img');
        img.src = URL.createObjectURL(file);
        img.alt = file.name;
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-form__preview-remove';
      btn.textContent = '\u00d7';
      btn.dataset.index = idx;
      btn.addEventListener('click', function () {
        selectedFiles.splice(parseInt(this.dataset.index, 10), 1);
        renderPreviews();
      });

      wrapper.appendChild(img);
      wrapper.appendChild(btn);
      previewsEl.appendChild(wrapper);
    });
  }

  // --- Build FormData for n8n webhook ---
  function buildWebhookFormData() {
    var fd = new FormData();

    // Hidden fields
    ['product_type', 'page_title', 'page_url', 'store', 'design', 'source_product'].forEach(function (name) {
      var el = form.querySelector('[name="' + name + '"]');
      if (el) fd.append(name, el.value);
    });

    // Text fields
    ['first_name', 'last_name', 'email', 'phone', 'stones', 'description'].forEach(function (name) {
      var el = form.querySelector('[name="' + name + '"]');
      if (el) fd.append(name, el.value.trim());
    });

    // Select fields
    ['jewelry_type', 'alloy', 'size', 'budget'].forEach(function (name) {
      var el = form.querySelector('[name="' + name + '"]');
      if (el && el.value) fd.append(name, el.value);
    });

    // Radio fields
    var subtypeRadio = form.querySelector('[name="jewelry_subtype"]:checked');
    if (subtypeRadio) fd.append('jewelry_subtype', subtypeRadio.value);

    // Photos
    selectedFiles.forEach(function (file, i) {
      fd.append('photo_' + i, file, file.name);
    });

    return fd;
  }

  // --- Filet Shopify : soumission NATIVE du form contact caché ---
  // Un fetch direct sur /contact répond 400 « Missing CAPTCHA token » : le
  // hCaptcha injecté par Shopify n'intercepte que les vrais événements submit.
  // On soumet donc en navigation pleine page, uniquement quand n8n échoue ;
  // au retour, ?contact_posted=true réaffiche l'écran de succès.
  function submitShopifyFallback() {
    var sf = document.getElementById('shopify-contact-fallback');
    if (!sf) return false;

    var email = (form.querySelector('[name="email"]').value || '').trim();
    var firstName = (form.querySelector('[name="first_name"]').value || '').trim();
    var lastName = (form.querySelector('[name="last_name"]').value || '').trim();
    var phone = (form.querySelector('[name="phone"]').value || '').trim();
    var desc = (form.querySelector('[name="description"]').value || '').trim();
    var productType = form.querySelector('[name="product_type"]').value || '';
    var pageTitle = form.querySelector('[name="page_title"]').value || '';

    var alloyEl = form.querySelector('[name="alloy"]');
    var budgetEl = form.querySelector('[name="budget"]');
    var sizeEl = form.querySelector('[name="size"]');
    var stonesEl = form.querySelector('[name="stones"]');
    var subtypeRadio = form.querySelector('[name="jewelry_subtype"]:checked');
    var jewelryTypeEl = form.querySelector('[name="jewelry_type"]');

    var type = subtypeRadio ? subtypeRadio.value
      : (jewelryTypeEl && jewelryTypeEl.value ? jewelryTypeEl.value : productType);

    var body = 'DEMANDE SUR-MESURE\n\n';
    body += 'Client : ' + firstName + ' ' + lastName + '\n';
    body += 'Email : ' + email + '\n';
    body += 'Telephone : ' + (phone || 'Non renseigne') + '\n';
    body += 'Type : ' + (type || 'Non precise') + '\n';
    body += 'Alliage : ' + (alloyEl && alloyEl.value ? alloyEl.value : 'Non precise') + '\n';
    body += 'Pierres : ' + (stonesEl && stonesEl.value ? stonesEl.value.trim() : 'Non precise') + '\n';
    body += 'Taille : ' + (sizeEl && sizeEl.value ? sizeEl.value : 'N/A') + '\n';
    body += 'Budget : ' + (budgetEl && budgetEl.value ? budgetEl.value : 'Non precise') + '\n';
    body += '\nDescription :\n' + desc + '\n';
    var designEl = form.querySelector('[name="design"]');
    if (designEl && designEl.value) body += 'Design : ' + designEl.value + '\n';
    body += '\nPage : ' + pageTitle + '\n';
    // L'origine d'acquisition ne passe que par n8n : dans le filet, elle voyage dans le message.
    var myr = typeof window.myrAttribution === 'function' ? window.myrAttribution() : '';
    var ft = null;
    try { ft = myr ? JSON.parse(myr).ft : null; } catch (e) {}
    if (ft) {
      body += 'Origine : ' + [ft.c, ft.s || ft.r, ft.cp, ft.p].filter(Boolean).join(' · ')
        + ' (' + new Date(ft.t * 1000).toISOString().slice(0, 10) + ')\n';
      body += 'myr_attribution : ' + myr + '\n';
    } else {
      body += 'Origine : inconnue\n';
    }
    // Ce message ne part que si n8n a echoue : les photos, elles, sont perdues
    // (le form contact Shopify ne porte pas de fichier).
    body += selectedFiles.length
      ? 'Photos : ' + selectedFiles.length + ' photo(s) choisie(s) mais NON RECUE(S) (envoi n8n en echec). Demander au client de les renvoyer par email.'
      : 'Photos : aucune';

    sf.querySelector('#sf-email').value = email;
    sf.querySelector('#sf-body').value = body;

    whenCaptchaBound(sf, function () {
      if (sf.requestSubmit) { sf.requestSubmit(); } else { sf.submit(); }
    });
    return true;
  }

  // --- Form submission (dual: Shopify + n8n) ---
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    hideMessages();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    // Anti-spam: honeypot rempli OU soumission trop rapide → on simule un succès et on n'envoie rien
    var honeypot = form.querySelector('[name="website"]');
    var loadedAt = parseInt(loadedAtEl && loadedAtEl.value, 10) || 0;
    var elapsed = Date.now() - loadedAt;
    if ((honeypot && honeypot.value) || (loadedAt && elapsed < MIN_FILL_MS)) {
      showSuccess();
      return;
    }

    setLoading(true);

    // n8n webhook — GSheet + Telegram + email confirmation + photos
    if (!webhookUrl) {
      // Pas de webhook configuré → le form Shopify porte l'envoi seul (navigation)
      if (!submitShopifyFallback()) showSuccess();
      return;
    }

    var fd = buildWebhookFormData();
    // origine d'acquisition (journal first-party du snippet myr-attribution), pour l'attribution des demandes
    var myr = typeof window.myrAttribution === 'function' ? window.myrAttribution() : '';
    if (myr) fd.append('myr_attribution', myr);

    function postToN8n() {
      return fetch(webhookUrl, { method: 'POST', body: fd }).then(function (res) {
        if (!res.ok) throw new Error('Server error: ' + res.status);
        return res.json().catch(function () { return {}; });
      });
    }

    // Une seconde tentative avant le filet : seul n8n transporte les photos.
    postToN8n()
      .catch(function () {
        return new Promise(function (resolve) { setTimeout(resolve, 2000); }).then(postToN8n);
      })
      .then(function () {
        showSuccess();
      })
      .catch(function () {
        // n8n en échec → filet Shopify en soumission native (la page navigue)
        if (!submitShopifyFallback()) showSuccess();
      });
  });

  function showSuccess() {
    setLoading(false);
    form.style.display = 'none';
    successEl.style.display = 'block';
    window.scrollTo({ top: container.offsetTop - 100, behavior: 'smooth' });
  }

  function setLoading(on) {
    container.classList.toggle('is-loading', on);
  }

  function showError(msg) {
    var bannerContent = errorEl.querySelector('.banner__content, p, span');
    if (bannerContent) bannerContent.textContent = msg;
    errorEl.style.display = 'block';
    successEl.style.display = 'none';
  }

  function hideMessages() {
    errorEl.style.display = 'none';
    successEl.style.display = 'none';
  }
})();
